import appConfig from '@nerdwallet/app-config';

export const getMonetizableValue = (marketplaceEntity, isBanking) => {
  // eslint-disable-next-line camelcase
  const { should_throttle_monetization, monetizable } =
    marketplaceEntity.derived_details;
  const isMonetizable = isBanking
    ? !should_throttle_monetization?.value
    : monetizable?.value;

  return isMonetizable ? 'yes_assumed' : 'no';
};

export const addCtaApplyNowLinkTracking = (
  marketplaceEntity,
  segmentImpressionId,
  pageViewId,
  isBanking
) => {
  if (marketplaceEntity.derived_details?.apply_link?.value) {
    const applyLinkUrl = marketplaceEntity.derived_details?.apply_link?.value;
    const delimeter = applyLinkUrl && applyLinkUrl.includes('?') ? '&' : '?';
    const segmentParams = new URLSearchParams({
      impression_pageview_id: pageViewId,
      sku_impression_id: segmentImpressionId,
      product_impression_id: segmentImpressionId,

      // eslint-disable-next-line no-underscore-dangle
      calling_deployable_name: appConfig?._meta?.deployable,
      // eslint-disable-next-line no-underscore-dangle
      calling_deployable_version: appConfig?._meta?.version,
      monetizable: getMonetizableValue(marketplaceEntity, isBanking),
    });

    const updatedUrl = `${applyLinkUrl}${delimeter}${segmentParams.toString()}`;

    return {
      ...marketplaceEntity,
      derived_details: {
        apply_link: {
          type: 'link',
          value: updatedUrl,
        },
      },
    };
  }
  return marketplaceEntity;
};
